import React, {useEffect, useContext} from "react"
import '../styles/global.scss';
import PortfolioSection from "../components/portfolio/portfolio-section.component";
import Hero from "../components/main-section/hero.component";
import Header from "../components/main-section/header.component";
import CarouselComponent from "../components/carousel-section/carousel.component";
import Contact from "../components/contact/contact.component";
// import Sidebar from "../components/sidebar/sidebar.component";
import Footer from "../components/footer/footer.component";
import { Helmet } from "react-helmet"
import favicon from '../../static/favicon.ico';
import { GlobalDispatchContext, GlobalStateContext } from '../context/globalContextProvider';

import Gdpr from '../components/gdpr/gdpr.component';
import PrivacyPolicy from '../components/privacy-policy/privacy-policy.component'


export default function Home() {
    const dispatch = useContext(GlobalDispatchContext);
    const { gdprIsOpen, policyIsOpen } = useContext(GlobalStateContext)

    // const [showSidebar, setShowSidebar] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        const visited = sessionStorage.getItem('visited');

        if (!visited) {
            dispatch({
                type: 'SET_GDPR_OPEN',
                gdprIsOpen: true
            })
        }

        sessionStorage.setItem('visited', true);
    }, [dispatch]);


  

    // const handleScroll = () => {
     
    //         if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
    //            setShowSidebar(false);
    //         } else {
    //             setShowSidebar(true);
    //         }  
    // }
    useEffect(() => {
        dispatch({
            type: 'SHOW_LOADING',
            isLoading: false
        })
        dispatch({
            type: 'HIDE_OVERFLOW',
            hideOverflow: false
        })
        // window.addEventListener('scroll', handleScroll)

        // return () => {
        //     window.removeEventListener('scroll', handleScroll);
        // }
    }, [dispatch])


  return (
    <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Ingrid Vocals</title>
          <script src="https://www.google.com/recaptcha/api.js" async defer></script> 
          <link rel="icon" href={favicon} />

        </Helmet>
 
            <Header />
            {/* {
                showSidebar &&

                    <Sidebar />
            } */}
            
            <Hero />
            <PortfolioSection />
            <CarouselComponent />
            <Contact />
            <Footer />
            {
                gdprIsOpen && <Gdpr />
            }
            {
                policyIsOpen && <PrivacyPolicy />
            }
    </div>  
  )
}
